
import { PropType, defineComponent } from 'vue';
import ConfirmationOverlay from './ConfirmationOverlay.vue';
import globalConstants from '@/shared/globalConstants';
import { isNullOrUndefined } from '@/shared/helpers';
const { knight, swift } = globalConstants.companies;

export default defineComponent({
    name: 'DriverLoaded',
    components: {
        ConfirmationOverlay,
    },
    props: {
        attachedTrailerNumber: {
            type: String as PropType<string | null>,
            required: false,
        },
        attachedTrailerCompany: {
            type: String as PropType<string | null>,
            required: true,
        },
        showDeepLinkButton: {
            type: Boolean,
            default: false,
        },
        association: {
            type: String as PropType<string | null>,
            default: null,
        },
        fromReservation: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['onSearchForTrailers', 'hideModal'],
    data: () => ({
        showAssessmentShaming: false,
        showNearTrailer: false,
    }),
    computed: {
        showDeepLink(): boolean {
            return this.showDeepLinkButton;
        },
        subtitleText() {
            return this.attachedTrailerNumber == null
                ? ''
                : `Trailer #${this.attachedTrailerNumber}`;
        },
        acceptText(): string {
            return this.showDeepLink === true
                ? `Return to ${this.returnApp} Dashboard`
                : 'Search for Trailers';
        },
        rejectText(): string {
            return this.fromReservation === true
                ? 'Go Back'
                : this.showDeepLink === true
                ? 'Search for Trailers'
                : '';
        },
        subheadingText(): string {
            if (!isNullOrUndefined(this.association)) {
                return `Please perform your normal empty call macro to continue with this ${this.association}ment.`;
            } else if (this.fromReservation === true) {
                return 'To hold this trailer, first perform your empty call macro then try again.';
            }
            return 'Please perform your normal empty call macro.';
        },
        returnApp(): string {
            const routeCompany = this.$route?.params?.company;

            if (
                this.attachedTrailerCompany === knight ||
                routeCompany === knight
            ) {
                return 'KT Mobile';
            } else if (
                this.attachedTrailerCompany === swift ||
                routeCompany === swift
            ) {
                return 'Pointe';
            } else {
                return '';
            }
        },
    },
    methods: {
        acceptAction() {
            if (this.showDeepLink === true) {
                window.location.href = 'eleos://dashboard';
                return;
            }

            this.searchForTrailers();
        },
        rejectAction() {
            if (this.fromReservation === true) {
                this.$emit('hideModal');
                return;
            }
            if (this.showDeepLink === true) {
                this.$router.push({ name: 'DriverLanding' });
                return;
            }

            this.searchForTrailers();
        },
        searchForTrailers() {
            this.$emit('onSearchForTrailers');
        },
    },
});
